import {useEffect, useState, useLayoutEffect} from 'react';

import {useApp} from '@app';
import {eventManager} from '@application/Event';
import {UiEvent} from '@domain/model/Event';
import {PageEventView} from '@domain/model/Event/domain/model/UiEvents';

export const usePageLoad = (view: PageEventView, payload = {}, inputs = []): void => {
  const {isPanelVisible} = useApp();
  const [isLastView, setIsLastView] = useState<undefined | boolean>();

  useLayoutEffect(() => {
    eventManager.emit(UiEvent.PAGE_LOAD, {view, ...payload});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, inputs);

  useEffect(() => {
    if (isPanelVisible) {
      setIsLastView(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPanelVisible]);

  useEffect(() => {
    if (isLastView && !isPanelVisible) {
      eventManager.emit(UiEvent.PAGE_LOAD, {view, ...payload});
      setIsLastView(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPanelVisible]);
};
